import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, Table } from 'react-bootstrap';
import LoaderButton from '../components/LoaderButton';
import {
  UpdateLocation,
  OpsLocations,
  UpdateOpsLocation,
} from '../libs/GraphQL';

export default class ChangeRoutes extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: false,
      fileContents: '',
      locations: [],
    };
    this.getOpsLocations = this.getOpsLocations.bind(this);
    this.makeChanges = this.makeChanges.bind(this);
    this.validateline = this.validateline.bind(this);
    this.validateFile = this.validateFile.bind(this);
    this.getLocationType = this.getLocationType.bind(this);
  }

  async componentDidMount() {
    try {
      this.getOpsLocations();
    } catch (e) {
      console.error(e);
    }
  }

  async getOpsLocations() {
    await OpsLocations().then((data) => {
      if (data.data.opsLocations && data.data.opsLocations.locations) {
        this.setState({
          locations: data.data.opsLocations.locations,
        });
      }
    });
  }

  async makeChanges(event) {
    this.setState({
      isLoading: true,
    });
    const localFileContents = this.state.fileContents.data;
    const remainingItems = [];

    for (let i = 0; i < localFileContents.length; i++) {
      const obj = localFileContents[i];
      if (this.validateline(obj) > 0) {
        const input = {
          id: obj.id.toString(),
          route: obj.route.toString().toLowerCase(),
          stop: parseInt(obj.stop, 10),
        };
        try {
          if (this.getLocationType(obj.id.toString()) === 'FRIDGE') {
            await UpdateLocation(input);
          } else if (this.getLocationType(obj.id.toString()) === 'WHOLESALE') {
            await UpdateOpsLocation(input);
          } else {
            remainingItems.push(obj);
          }
        } catch (e) {
          console.error(e);
          remainingItems.push(obj);
        }
      } else if (this.validateline(obj) < 0) {
        remainingItems.push(obj);
      }
    }
    // eslint-disable-next-line react/no-access-state-in-setstate
    const fileContents = this.state.fileContents;
    fileContents.data = remainingItems;
    this.setState({
      fileContents,
      isLoading: false,
    });
  }

  // TODO: rewrite function to prevent param reassigning
  handleFileChange = (event) => {
    this.setState({
      fileContents: '',
    });
    window.Papa.parse(event.target.files[0], {
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        // eslint-disable-next-line no-param-reassign
        results.data = results.data.map((item) => {
          // eslint-disable-next-line no-param-reassign
          item.id = item.id.toString();
          return item;
        });

        this.setState({
          fileContents: results,
        });
      }.bind(this),
    });
    this.setState({
      // TODO: Check if can we safety remove this unused state
      // eslint-disable-next-line react/no-unused-state
      file: event.target.files[0],
    });
  };

  validateline(item) {
    const value = this.getLocationType(item.id);
    if (!value) {
      // location not found in Operations table
      return -1;
    }
    const item_keys = Object.keys(item);
    const keys = ['id', 'route', 'stop'];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (!item_keys.includes(key)) {
        return -1;
      }
    }
    return 1;
  }

  validateFile() {
    if (this.state.fileContents === '') {
      return true;
    }
    return false;
  }

  getLocationType(id) {
    const locations =
      this.state.locations &&
      this.state.locations.filter((obj) => {
        return obj.id === id;
      });
    if (locations && locations.length > 0) {
      return locations[0].type;
    }
  }

  render() {
    let headers;
    let rows;
    if (this.state.fileContents !== '') {
      headers = ['id', 'route', 'stop', 'status'].map((header) => (
        <th key={header}>{header}</th>
      ));
      rows = this.state.fileContents.data.map(
        function (obj) {
          const tds = ['id', 'route', 'stop'].map((header) => (
            <td key={header}>{obj[header]}</td>
          ));
          tds.push(
            <td key="status">
              {' '}
              {this.validateline(obj) > 0 && <Glyphicon glyph="ok" />}
              {this.validateline(obj) < 0 && (
                <Glyphicon glyph="exclamation-sign" />
              )}
            </td>,
          );
          return <tr key={obj.id + obj.route + obj.stop}>{tds}</tr>;
        }.bind(this),
      );
    }

    return (
      <div className="Locations">
        <FormGroup controlId="file">
          <FormControl
            onClick={(event) => {
              // eslint-disable-next-line no-param-reassign
              event.target.value = null;
            }}
            onChange={this.handleFileChange}
            type="file"
          />
        </FormGroup>

        {this.state.fileContents !== '' && (
          <Table bordered responsive>
            <thead>
              <tr>{headers}</tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        )}

        <LoaderButton
          block
          bsStyle="primary"
          bsSize="large"
          disabled={this.validateFile()}
          onClick={this.makeChanges}
          type="submit"
          isLoading={this.state.isLoading}
          text="Upload Drivers"
          loadingText="Uploading Drivers…"
        />
      </div>
    );
  }
}
